import { render, staticRenderFns } from "./SkuInfo.vue?vue&type=template&id=19a2d040&scoped=true"
import script from "./SkuInfo.vue?vue&type=script&lang=js"
export * from "./SkuInfo.vue?vue&type=script&lang=js"
import style0 from "./SkuInfo.vue?vue&type=style&index=0&id=19a2d040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a2d040",
  null
  
)

export default component.exports